import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7 21H5V19H2V17H5V15H7V21ZM22 19H9V17H22V19ZM17 15H15V13H2V11H15V9.012H17V15ZM22 13H19V11H22V13ZM11 9H9V7H2V5H9V3H11V9ZM22 7H13V5H22V7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Slider03"
);
